import { LocalKeys } from '@sorare/core/src/lib/storage/localStorage';
import { SessionKeys } from '@sorare/core/src/lib/storage/sessionStorage';

const QUERY_PARAMS = {
  utm_source: 'utm_source',
  referrer: 'referrer',
  utm_medium: 'utm_medium',
  utm_campaign: 'utm_campaign',
  utm_term: 'utm_term',
  utm_content: 'utm_content',
  irclickid: 'irclickid',
  gclid: 'gclid',
  fbclid: 'fbclid',
  twclid: 'twclid',
  ttclid: 'ttclid',
  ScCid: 'ScCid',
  rdt_cid: 'rdt_cid',
  invitation_token: 'invitation_token',
  traffic_category: 'traffic_category',
  partner: 'partner',
  user: 'user',
  force_env: 'force_env',
  force_flag: 'force_flag',
  mobileApp: 'mobileApp',
  appBuildVersionNumber: 'appBuildVersionNumber',
  googlePlayStoreCountryCode: 'googlePlayStoreCountryCode',
  storefrontCountryCode: 'storefrontCountryCode',
  debugI18n: 'debugI18n',
  deeplink: 'deeplink',
} as const;

export const queryParamsToLocalStorageKeys = {
  [QUERY_PARAMS.utm_source]: LocalKeys.utm_source,
  [QUERY_PARAMS.referrer]: LocalKeys.referrer,
  [QUERY_PARAMS.utm_medium]: LocalKeys.utm_medium,
  [QUERY_PARAMS.utm_campaign]: LocalKeys.utm_campaign,
  [QUERY_PARAMS.utm_term]: LocalKeys.utm_term,
  [QUERY_PARAMS.utm_content]: LocalKeys.utm_content,
  [QUERY_PARAMS.irclickid]: LocalKeys.impact_clickid,
  [QUERY_PARAMS.gclid]: LocalKeys.google_clickid,
  [QUERY_PARAMS.fbclid]: LocalKeys.facebook_clickid,
  [QUERY_PARAMS.twclid]: LocalKeys.twitter_clickid,
  [QUERY_PARAMS.ttclid]: LocalKeys.tiktok_clickid,
  [QUERY_PARAMS.ScCid]: LocalKeys.snapchat_clickid,
  [QUERY_PARAMS.rdt_cid]: LocalKeys.reddit_clickid,
  [QUERY_PARAMS.invitation_token]: LocalKeys.invitation_token,
  [QUERY_PARAMS.traffic_category]: LocalKeys.traffic_category,
  [QUERY_PARAMS.partner]: LocalKeys.partner,
  [QUERY_PARAMS.user]: LocalKeys.user,
} as const;

export const queryParamsToSessionStorageKeys = {
  [QUERY_PARAMS.force_env]: SessionKeys.forcedEnv,
  [QUERY_PARAMS.force_flag]: SessionKeys.forcedFlag,
  [QUERY_PARAMS.mobileApp]: SessionKeys.mobileApp,
  [QUERY_PARAMS.appBuildVersionNumber]: SessionKeys.appBuildVersionNumber,
  [QUERY_PARAMS.googlePlayStoreCountryCode]:
    SessionKeys.googlePlayStoreCountryCode,
  [QUERY_PARAMS.storefrontCountryCode]: SessionKeys.storefrontCountryCode,
  [QUERY_PARAMS.debugI18n]: SessionKeys.debugI18n,
  [QUERY_PARAMS.deeplink]: SessionKeys.deeplink,
} as const;
